import './AllocationMap.css';
import React, { useContext } from 'react';
import { Card } from '../../../../../components/Card/Card';
import { t } from '../../../../../locales/translate';
import { Event } from '../../../../../model/event';
import { Seatmap } from '../../../../../components/Seatmap/Seatmap';
import { SeatmapEditBox } from '../../../../../components/Seatmap/SeatmapEditBox';
import { ContingentEditForm } from '../../../../../components/Seatmap/ContingentEditForm';
import { ContingentList } from '../../../../../components/Seatmap/ContingentList';
import { Split } from '../../../../../components/Split/Split';
import { ActivitiesContext } from '../../../../../components/Activities/Activities';
import { Spacer } from '../../../../../components/Spacer/Spacer';
import { Icon } from '../../../../../components/Icon/Icon';

interface Props {
  event: Event;
}

export function AllocationMap({ event }: Props): JSX.Element {
  const { reloadActivities } = useContext(ActivitiesContext);

  return (
    <Card
      title={t.model.venueLayout.seatsAndBlocks}
      actions={
        <a
          className="button button--small"
          href={event.allocationPdfDownloadUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="download--sm" />
          {t.model.allocation.downloadPdf}
        </a>
      }
    >
      <Seatmap layoutId={event.venueLayout.id} eventId={event.id} mode="allocation">
        {({ seatmap }) =>
          seatmap.allocationEditable && (
            <>
              {seatmap.selection.seats.size > 0 && (
                <SeatmapEditBox
                  seatmap={seatmap}
                  selectedSeats={Array.from(seatmap.selection.seats)}
                  onDeselectAll={() => {
                    seatmap.selection.clear();
                    reloadActivities();
                  }}
                />
              )}
              {seatmap.selection.section && (
                <Card title={seatmap.selection.section.name} className="allocation-map__big-overlay" size="medium">
                  <Spacer size="xs" />
                  <Split ratio={0.7}>
                    <ContingentList event={event} section={seatmap.selection.section} allowEditingCapacity />
                    <ContingentEditForm
                      onSubmit={() => seatmap.reloadAllocation()}
                      section={seatmap.selection.section}
                      event={event}
                      onDeselect={() => {
                        seatmap.selection.clear();
                        reloadActivities();
                      }}
                    />
                  </Split>
                </Card>
              )}
            </>
          )
        }
      </Seatmap>
    </Card>
  );
}
